export default __webpack_public_path__ + "static/media/vidhur.075f97a4.png";